import './Radio.scoped.sass'

export function Radio (props) {
  const {
    disabled = false,
    checked = false,
    name = '',
    label = '',
    onChecked = () => {},
  } = props

  const onChange = () => {
    if (onChecked) onChecked()
  }

  return <div className='radio-item'>
    <input type="radio" disabled={disabled} id={name} name={name} checked={checked}/>
    <label htmlFor={name} onClick={onChange} title={label}>
      {label}
    </label>
  </div>
}
